import { PaymentMethodStatus, PaymentCategoryType } from 'consts';

export default class ActivePaymentMethod {
  paymentList: IPaymentMethod[];

  constructor(paymentList: IPaymentMethod[]) {
    this.paymentList = paymentList;
  }

  getActivePaymentMethod() {
    if (this.paymentList.length === 0) {
      return PaymentCategoryType.BLIK;
    }

    const enabledPaymentMethods = this.paymentList
      .map(a => a.paymentMethods)
      .reduce((a, b) => a.concat(b), [])
      .filter(paymentMethod => paymentMethod.status === PaymentMethodStatus.ENABLED);

    return enabledPaymentMethods.length > 0
      ? this.paymentList.filter(e => e.paymentMethods.find(value => value.id === enabledPaymentMethods[0].id))[0].type
      : this.paymentList[0].type;
  }
}
